import { Divider } from 'antd';
import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import { StringFilterDataGrid } from 'app/common/ui/data-grid/filters';
import { CanAccess } from 'app/railways/domains/access/features/permissions';
import { appRoute } from 'app/railways/router/routes';

import { TReportTemplate } from '../../core/report';

export const cols: TEntityGridColumn<TReportTemplate>[] = [
  {
    field: 'id',
    headerName: 'ID',
    minWidth: 50,
    maxWidth: 100,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const path = appRoute.REPORT.buildPath({
        id: value,
      });

      return <Link to={path}>{value}</Link>;
    },
    filter: StringFilterDataGrid({
      filterName: 'id',
      placeholder: 'Введите ID пользователя',
    }),
  },
  {
    field: 'name',
    // type: 'rightAligned',
    headerName: 'Название',
    minWidth: 50,
    colId: 'name',
    sortable: false,
    comparator: () => 0,
  },
  {
    headerName: 'Просмотр',
    colId: 'preview',
    sortable: false,
    comparator: () => 0,

    cellRenderer: ({ data }: { data: TReportTemplate }) => {
      const viewReportPath = appRoute.REPORT.buildPath({
        id: data.id,
      });

      const editReportPath = appRoute.REPORT_EDIT.buildPath({
        id: data.id,
      });

      return (
        <div>
          <Link to={viewReportPath}>Открыть</Link>
          <CanAccess perm="PERM_REPORT_TEMPLATE_UPDATE">
            <>
              <Divider type="vertical" style={{ margin: '0 16px' }} />
              <Link to={editReportPath}>Редактировать</Link>
            </>
          </CanAccess>
        </div>
      );
    },
  },
];
